import { LOCALES, type Locale } from "@/config/i18n";

/**
 * Persistance du choix EXPLICITE de langue (clic sur le switcher).
 *
 * ≠ détection de la langue du navigateur (Accept-Language), que Google
 * déconseille et qu'on n'utilise PAS. Ici on ne mémorise QUE le choix volontaire
 * de l'utilisateur, pour le restituer à sa prochaine visite (cf. LocalePreference).
 */
export const LOCALE_PREF_KEY = "ks-preferred-locale";

/** Lit la préférence de langue explicite (null si aucune / invalide / SSR). */
export const getPreferredLocale = (): Locale | null => {
  if (typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(LOCALE_PREF_KEY);
    return value && (LOCALES as readonly string[]).includes(value)
      ? (value as Locale)
      : null;
  } catch {
    return null;
  }
};

/** Mémorise le choix explicite de langue (localStorage + cookie 1 an). */
export const setPreferredLocale = (locale: Locale): void => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(LOCALE_PREF_KEY, locale);
  } catch {
    /* localStorage indisponible (mode privé strict) — on ignore. */
  }
  try {
    // Cookie en complément (1 an) : utile si un redirect edge SSR est ajouté
    // plus tard, et survit à un éventuel nettoyage du localStorage.
    document.cookie = `${LOCALE_PREF_KEY}=${locale}; path=/; max-age=31536000; samesite=lax`;
  } catch {
    /* ignore */
  }
};
